module.exports = __webpack_public_path__ + "img/index-appoint-btn.9a63642d.png";